import { ServiceCollectionData } from './claim-state.interface';
import { ContactDetailsFormValuesContainer } from './contact-details.interface';

export interface FormCollectionData {
  [ServiceCollectionData.COLLECTION_ADDRESS]?: ContactDetailsFormValuesContainer;
  [ServiceCollectionData.DELIVERY_RETURN_ADDRESS]?: ContactDetailsFormValuesContainer;
}
